var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"page-header\">\n<div class=\"wb-login-info\">\n<h3 class=\"text-center\">Log in to view bookings and manage your account</h3>\n<p class=\"text-center\"></p>\n</div>\n</div>\n<div class=\"sign-in-container\">\n<div bb-member-login bb-custom-login-form>\n</div>\n<div bb-login>\n<div>\n<form class=\"form-horizontal\">\n<div class=\"form-group\">\n<div class=\"col-sm-offset-4 col-sm-5\">\n<div class=\"wb-guest-help\">\nForgotten your password?\n<br/>\n<a ng-click=\"sendPasswordReset(login.email)\">Send password reset email</a>\n</div>\n</div>\n</div>\n</form>\n</div>\n</div>\n</div>";
var id1="member/_templates/steps/login.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/sdk-templates/member/_templates/steps/login.html
// module id = 1253
// module chunks = 0